var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCircleArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 45"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 36081"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 36080"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 636",
    fill: "none",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "noun-arrow-1787131-FFFFFF (1)",
    d: "M28.214 22.248a.689.689 0 00-.232-.454l-8.354-7.541a1.029 1.029 0 00-.644-.251 1.07 1.07 0 00-.674.193.712.712 0 00-.307.524.679.679 0 00.24.547l7.8 7.035-7.8 7.035a.679.679 0 00-.24.547.711.711 0 00.307.524 1.071 1.071 0 00.674.193 1.029 1.029 0 00.644-.251l8.354-7.541a.671.671 0 00.232-.56z",
    fill: "currentColor"
  }))));
}

export default SvgCircleArrow;